//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { AddressDTO } from 'src/app/core/models/system/mapping/address.dto';
import CustomStore from 'devextreme/data/custom_store';
import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { lastValueFrom, map, Observable, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class AddressesService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }
    
  public getById(id: number): Observable<AddressDTO> {
    try {
      return this.httpClientService.getById(environment.eSimApi + eSimApiPaths.Addresses + "/", id);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescription(): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.httpClientService.get<AddressDTO[]>(environment.eSimApi + eSimApiPaths.Addresses)
      .pipe(
        map(x => x.map(this.idAndDescriptionConverter))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndPostcode(): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.httpClientService.get<AddressDTO[]>(environment.eSimApi + eSimApiPaths.Addresses)
      .pipe(
        map(x => x.map(this.idAndPostcodeConverter))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
    
  public getPostCode(id: number): Observable<StringResultDTO> {
    try {
      return this.httpClientService.get<StringResultDTO>(environment.eSimApi +
                                                         eSimApiPaths.Addresses + "/" +
                                                         eSimApiPaths.AddressesGetPostcode +
                                                         "?id=" + id);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getPostcodeSearchAddresses(postcode: string): Observable<AddressDTO[]> {
    try {
      return this.httpClientService.get<AddressDTO[]>(environment.eSimApi +
                                                      eSimApiPaths.Addresses + "/" +
                                                      eSimApiPaths.AddressesPostcodeSearch +
                                                      "?postCode=" + postcode);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(address: AddressDTO) {
    return {id: address.id, description: address.line1 + " " + address.postCode};
  }

  public idAndDescriptionLookupDataSource(): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription());
          }
        }),
        sort: "description"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }

  private idAndPostcodeConverter(address: AddressDTO) {
    return {id: address.id, description: address.postCode};
  }

  public idAndPostcodeLookupDataSource(): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndPostcode());
          }
        }),
        sort: "description"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }
  
  public post(address: AddressDTO): Observable<AddressDTO> {
    try {
      //JSON.stringify(user)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(address), true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.Addresses +
                                                               "?objectEncSS=" + objectEncSS, {});
                         })
                  );      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
      
  public put(address: AddressDTO): Observable<AddressDTO> {
    try {
      //JSON.stringify(user)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(address), true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEncSS=encResult.result;
                            
                            return this.httpClientService.put(environment.eSimApi +
                                                              eSimApiPaths.Addresses +
                                                              "?id=" + address.id +
                                                              "&objectEncSS=" + objectEncSS, undefined, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
        
  public save(address: AddressDTO): Observable<AddressDTO> {
    try {
      //JSON.stringify(modal);
      if (address.id && <number>address.id>0)
        return this.put(address);
                  
      return this.post(address);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
